import { PublicCourseReview } from '@shared/types';
import { useEffect, useMemo, useState } from 'react';
import GetCourseReviews from '../../Queries/GetCourseReviews';

type Next = null | (() => Promise<void>);

export type Response = [Array<PublicCourseReview>, Next];

const useCourseReviews = (educatorSlug: string, courseSlug: string): Response => {
    const [reviews, setReviews] = useState<Array<PublicCourseReview>>([]);
    const [nextPage, setNextPage] = useState<string | undefined>(undefined);

    useEffect(() => {
        fetchReviews(educatorSlug, courseSlug, undefined).then((response) => {
            setReviews(response.reviews);
            setNextPage(response.nextPageToken ?? undefined);
        });
    }, [courseSlug, educatorSlug]);

    const next: Next = useMemo(() => {
        if (nextPage) {
            return () =>
                fetchReviews(educatorSlug, courseSlug, nextPage).then((response) => {
                    setReviews(reviews.concat(response.reviews));
                    setNextPage(response.nextPageToken ?? undefined);
                });
        }

        return null;
    }, [courseSlug, educatorSlug, nextPage, reviews]);

    return [reviews, next];
};

const fetchReviews = (educatorSlug: string, courseSlug: string, nextPage: string | undefined) => {
    return GetCourseReviews(educatorSlug, courseSlug, nextPage).catch((err) => {
        console.error(err);

        return {
            reviews: [],
            nextPageToken: undefined,
        };
    });
};

export default useCourseReviews;
